import { Box, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const sellerDataDialogPaperPropsStyle = {
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  maxWidth: '37.5rem',
  width: '100%',
  height: '46rem',
  padding: '1.5rem',
  position: 'relative',

  [theme.breakpoints.up('sm')]: {
    height: '38.7rem',
    padding: '1.5rem',
  },
};
export const TagSpaceInputAndCpf = styled('div')(() => ({
  height: '5rem',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  marginTop: '1rem',
}));

export const StyledIconButton = styled('button')(({ theme }) => ({
  position: 'absolute',
  right: '1rem',
  color: theme.palette.common.white,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
}));

export const StyledDialogContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem',
  textAlign: 'center',
  padding: '1rem',
  width: '100%',
  maxHeight: '40rem',
}));

export const StyledImage = styled('img')({
  width: '12rem',
  height: '12rem',

  [theme.breakpoints.up('sm')]: {
    width: '9rem',
    height: '9rem',
  },

  [theme.breakpoints.up('md')]: {
    width: '10rem',
    height: '10rem',
  },
});

export const StyledButtonContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  width: '100%',
  height: '100%',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '1rem',
  },
});
